import axios from 'axios';

// API base URL comes from build-time env (REACT_APP_API_URL). Falls back to a
// same-origin relative path so deployments behind a single domain still work.
export const baseURL = (process.env.REACT_APP_API_URL || '/api/v1').replace(/\/$/, '');

console.log('API base URL:', baseURL);

const axiosInstance = axios.create({
  baseURL,
  headers: { 'Content-Type': 'application/json' },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => {
    const body = response.data;
    if (body && typeof body === 'object' && body.success === true && 'data' in body) {
      response.meta = body.meta;
      response.data = body.data;
    }
    return response;
  },
  (error) => {
    if (error.response) {
      const body = error.response.data;
      if (body && typeof body === 'object' && body.success === false && body.error) {
        error.apiError = body.error;
        error.message = body.error.message || error.message;
        // Call sites read `err.response?.data?.error` and expect a string;
        // flatten the envelope object so they never render "[object Object]".
        if (typeof body.error === 'object') {
          const details = Array.isArray(body.error.details)
            ? body.error.details.map((d) => [d.path, d.message].filter(Boolean).join(': ')).join('; ')
            : '';
          body.error = details
            ? `${body.error.message} — ${details}`
            : (body.error.message || 'Request failed');
        }
      }

      if (error.response.status === 401) {
        const url = error.config?.url || '';
        const isAuthFlow = url.includes('/auth/login/verify') || url.includes('/auth/login');
        if (!isAuthFlow) {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          window.location.href = '/';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
